<ng-template #newTaskTemplate>
	<mod-task-form (create)="handleCreateTask($event)" [isInDialog]="true"></mod-task-form>
</ng-template>

@if (enableEdit()) {
<div class="push-bottom">
	<lib-button-list [buttons]="mainButtons()"></lib-button-list>
</div>

} @if (assignedTasksListItems(); as assignedTasksListItems) {

<lib-card>
	<lib-list
		[noItemsText]="authUserIsClient() ? 'You have no assigned tasks' : 'Client has no assigned tasks'"
		[items]="assignedTasksListItems"
	></lib-list>
</lib-card>
} @else {
<lib-message [icon]="'task'" [type]="'noDataOnBody'"
	>@if (authUser()?.userType === 'client') {
	<span>You have no assigned tasks.</span>
	} @else {
	<span>Client has no tasks assigned</span>
	}</lib-message
>
}
